import Apod from "../components/Apod"

function Home() {
  return (
    <div>
      <h1>Astronomy Picture of the Day</h1>
      <Apod />
    </div>
  )
}

export default Home
